module.exports = __webpack_public_path__ + "static/media/image.3d1c9d6d.jpg";